<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import A from "../lib/Router/A.svelte";
    import {sort, copyObjectData} from "../lib/lib";
    import R, {LOADER} from "../lib/requests";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AccountEdit from "./AccountEdit.svelte";
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";


    let accounts = null;
    let selectedId = 0;

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE ACCOUNT', link: '/app/account/create', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', link: '/app/account/create', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'NAME', sortable: true, sort_way: 'ASC'},
        {key: 'hotels', title: 'HOTELS', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: 'departments', title: 'DEPARTMENTS', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            accounts = result;
        }

        const onFailure = err => {
        };

        R.handle(R.account.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail: column}) => {
        accounts = sort(accounts, column.key, column.sort_way === 'ASC');
    }

    const updateRecord = (account) => {
        let item = accounts.find(x => x.id === account.id);
        if (!item) {
            accounts = [account, ...accounts];
        } else {
            copyObjectData(account, item);
            accounts = accounts;
        }
    }

    const onCreate = () => {
        router.go(`/app/account/create`)();
    }

    const onEdit = (account) => {
        selectedId = account.id;
        router.go(`/app/account/${selectedId}`)();
    }

    const onDelete = (account) => {
        Alert.delete("Delete account", `This will permanently delete account "${account.name}".\nAre you sure?`, () => deleteAccount(account.id));
    }

    const deleteAccount = (id) => {
        const onSuccess = result => {
            accounts = accounts.filter(x => x.id !== result);
            Notifier.showMessage("Account deleted");
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                let message = [];

                Object.keys(err.params).map(key => {
                    if (err.params[key] > 0) {
                        message.push(`${err.params[key]} ${key}`);
                    }
                });

                Alert.warning("Delete account", `Account is associated with ${message.join(", ")}.\nYou can not delete this account.`);
            }
        };

        R.handle(R.account.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onPrices = (id) => {

    }

    load();
</script>

<Route exact>
    <PageHeader title="Accounts" controls={ pageHeaderControls } on:reload={ load }/>

    {#if accounts}
        <div class="panel">
            <div class="panel-body">
                {#if accounts.length}
                    <table class="table table-list table-list-border">
                        <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                        <tbody>
                        {#each accounts as account}
                            <tr class="row-hover" class:row-selected="{ selectedId === account.id }">
                                <td>
                                    <span class="is-link" class:not-active={ account.is_active < 1 }
                                          on:click="{ () => onEdit(account) }">
                                        { account.name }
                                    </span>
                                </td>
                                <td class="hidden-sm hidden-xs">
                                    {#each account.hotels as hotel}
                                        <div>
                                            <A href="/app/hotel/{ hotel.id }" class="text-gray is-link">
                                                <span class:not-active={ hotel.is_active < 1 }>
                                                    { hotel.name }
                                                </span>
                                            </A>
                                        </div>
                                    {/each}
                                </td>
                                <td class="hidden-sm hidden-xs">
                                    {#each account.departments as department}
                                        <A href="/app/department/{ department.id }">
                                            <ColoredNameControl name="{ department.name }" color="{ department.color }"
                                                                colorName isLink isActive="{ department.is_active  }"/>
                                        </A>
                                    {/each}
                                </td>
                                <td class="button-column pointer" title="delete account" on:click="{ () => onDelete(account) }">
                                    <AppIcon icon="trash" size="16"/>
                                </td>
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                {:else}
                    <div class="panel-pad">
                        <p>
                            There are no accounts
                        </p>
                        <A href="/app/account/create" class="btn btn-primary">CREATE AN ACCOUNT</A>
                    </div>
                {/if}
            </div>
        </div>
    {/if}
</Route>
<Route match="*" let:router>
    <AccountEdit updateCallback="{ updateRecord }" accountId="{ router.star }"/>
</Route>